import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { ServerUrls } from '~commonInfra/url/ServerUrls';
import { getFavoriteRedirectBasePaths } from '~src/favorites/models/FavoriteRedirects';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

export namespace BasePathsUtils {
  export function getWatchedBasePathsForServer() {
    const serverUrls = ServerUrls.getInstance();
    return _.compact([
      serverUrls.sitesPath(),
      serverUrls.jobsPath(),
      serverUrls.schedulesPath(),
      serverUrls.baseUserPath(),
      serverUrls.serverStatusVizPath(''),
      serverUrls.settingsExtensionsPath(),
      serverUrls.settingsLicensesPath(),
      serverUrls.settingsPath(),
      serverUrls.settingsCustomizationPath(),
      serverUrls.addSitePath(),
      serverUrls.statusPath(),
      serverUrls.tasksPath()
    ]);
  }

  export function getWatchedBasePathsForSite(urls: SpacesSiteUrls) {
    return _.compact<_.List<string | false>>([
      urls.baseUserPath(),
      urls.usersPath(),
      urls.favoritesPath(),
      urls.recentsPath(),
      urls.projectPath(''),
      urls.datasourcePath(''),
      urls.flowPath(''),
      urls.virtualConnectionPath(''),
      urls.workbookPath(''),
      urls.workbooksPath(),  // this also handles the revision history paths
      urls.searchPath(),
      urls.groupsPath(),
      urls.groupSetsPath(),
      urls.homePath(),
      urls.recommendationListPath(),
      urls.statusPath(),
      urls.explorePath(),
      urls.projectsPath(),
      urls.flowsPath(),
      urls.virtualConnectionsPath(),
      urls.viewsPath(),
      urls.datasourcesPath(),
      urls.tasksPath(),
      FeatureFlags.jobManagementEnabled && urls.jobsPath(),
      urls.schedulesPath(),
      urls.redirectToViewPath(''),
      urls.redirectToFavoriteViewPath(''),
      ...getFavoriteRedirectBasePaths(urls),
      urls.exploreDatasourcePath(''),
      urls.dataAlertPath(), // for remove and add data alerts
      urls.catalogPath(),
      urls.siteStatusVizPath(''),
      urls.settingsPath(),
      urls.settingsExtensionsPath(),
      urls.settingsBridgePath(),
      urls.settingsDataConnectPath(),
      urls.settingsPrivateConnectPath(),
      urls.settingsSecurityPath(),
      urls.settingsAuthenticationPath(),
      urls.collectionsPath(),
      urls.startersPath(),
      urls.sharedWithMePath(),
      urls.personalSpacePath(),
    ]);
  }
}
